
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
    description: String,
  },
})
export default class Copyrights extends Vue {
  text!: string;
  description!: string;
  label = `© ${new Date().getFullYear()} ${this.text}`;
}
